import { ActivatedRoute, Router } from '@angular/router';

/** Merges into the segment's matrix params; a null or empty value drops the key — an empty `from=` is a 422. */
export function patchParams(router: Router, route: ActivatedRoute, changes: Record<string, string | number | null>, replaceUrl?: boolean): void {
    const merged = { ...route.snapshot.params, ...changes };
    const params = Object.fromEntries(Object.entries(merged).filter(([, value]) => value !== null && value !== ''));

    router.navigate([params], { relativeTo: route, replaceUrl });
}
